import React from 'react';

const BLOB_CONFIGS = {
  hero: [
    { color: '#0066ff', size: 400, top: '10%', left: '-5%', animation: 'blobMorph1', duration: '20s' },
    { color: '#8b44ff', size: 300, top: '60%', right: '10%', animation: 'blobMorph2', duration: '25s' },
    { color: '#00d4ff', size: 250, top: '30%', right: '-5%', animation: 'blobMorph3', duration: '22s' },
  ],
  personal: [
    { color: '#ff0844', size: 350, top: '5%', left: '10%', animation: 'blobMorph2', duration: '24s' },
    { color: '#0066ff', size: 300, top: '50%', right: '5%', animation: 'blobMorph1', duration: '20s' },
    { color: '#8b44ff', size: 280, top: '70%', left: '30%', animation: 'blobMorph3', duration: '26s' },
  ],
  projects: [
    { color: '#8b44ff', size: 380, top: '15%', right: '10%', animation: 'blobMorph1', duration: '22s' },
    { color: '#00d4ff', size: 320, top: '55%', left: '5%', animation: 'blobMorph3', duration: '28s' },
    { color: '#0066ff', size: 260, top: '80%', right: '25%', animation: 'blobMorph2', duration: '20s' },
  ],
  blog: [
    { color: '#6366f1', size: 350, top: '10%', right: '15%', animation: 'blobMorph3', duration: '25s' },
    { color: '#ff0844', size: 280, top: '60%', left: '10%', animation: 'blobMorph1', duration: '22s' },
    { color: '#00d4ff', size: 300, top: '40%', left: '50%', animation: 'blobMorph2', duration: '27s' },
  ],
  contact: [
    { color: '#ff0844', size: 320, top: '20%', left: '5%', animation: 'blobMorph2', duration: '23s' },
    { color: '#8b44ff', size: 280, top: '50%', right: '10%', animation: 'blobMorph1', duration: '26s' },
    { color: '#0066ff', size: 250, top: '75%', left: '40%', animation: 'blobMorph3', duration: '21s' },
  ],
};

const LiquidBlobs = ({ section = 'hero' }) => {
  const blobs = BLOB_CONFIGS[section] || BLOB_CONFIGS.hero;

  return (
    <div className="blob-container" aria-hidden="true">
      {blobs.map((blob, index) => (
        <div
          key={index}
          className="liquid-blob"
          style={{
            width: blob.size,
            height: blob.size,
            background: `radial-gradient(circle, ${blob.color} 0%, transparent 70%)`,
            top: blob.top,
            left: blob.left,
            right: blob.right,
            animation: `${blob.animation} ${blob.duration} ease-in-out infinite`,
            animationDelay: `${index * -5}s`,
          }}
        />
      ))}
    </div>
  );
};

export default LiquidBlobs;
